import {createContext} from 'react'
import type {DayItem, TimeEntry} from '@package/shared'
import type {
  AcceptRecommendationRequest,
  AddTimeEntryRequest,
  RejectRecommendationRequest,
  UpdateTimeEntryRequest,
} from '@app/api-resolver/router'

export type DayItemsContextValue = {
  dayItems: DayItem[]
  dayItemsWithMerged: DayItem[]
  refetch: () => Promise<void>
  loading: boolean

  addTimeEntry: (timeEntry: AddTimeEntryRequest) => Promise<TimeEntry>
  updateTimeEntry: (timeEntry: UpdateTimeEntryRequest) => Promise<TimeEntry>
  deleteTimeEntry: (timeEntry: TimeEntry) => Promise<void>

  acceptRecommendation: (recommendation: AcceptRecommendationRequest) => Promise<TimeEntry>
  rejectRecommendation: (recommendation: RejectRecommendationRequest) => Promise<void>
}

export const DayItemsContext = createContext<DayItemsContextValue>({} as DayItemsContextValue)
